module.exports = __webpack_public_path__ + "img/ws.414be2a7.svg";